"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addContactPhoneSelector = exports.addContactEmailSelector = exports.addContactWarningSlotSelector = exports.addContactLoadingSlotsSelector = exports.addContactLoadingSlotSelector = exports.addContactStepSelector = exports.addContactStateSelector = exports.addContactReducer = exports.initialAddContactState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const addContactClearStore_1 = require("./addContactClearStore");
const addContactEmailExchangeCodeSaga_1 = require("./addContactEmailExchangeCodeSaga");
const addContactEmailResendCodeSaga_1 = require("./addContactEmailResendCodeSaga");
const addContactEmailSendCodeSaga_1 = require("./addContactEmailSendCodeSaga");
const addContactLoadingSlot_1 = require("./addContactLoadingSlot");
const addContactPhoneExchangeCodeSaga_1 = require("./addContactPhoneExchangeCodeSaga");
const addContactPhoneResendCodeSaga_1 = require("./addContactPhoneResendCodeSaga");
const addContactPhoneSendCodeSaga_1 = require("./addContactPhoneSendCodeSaga");
const addContactStep_1 = require("./addContactStep");
const addContactWarning_1 = require("./addContactWarning");
exports.initialAddContactState = {
    step: addContactStep_1.AddContactStep.SKIP,
    email: {
        email: null,
        tokenExchangeSuccess: undefined,
    },
    phone: {
        phone: null,
        tokenExchangeSuccess: undefined,
    },
    loadingSlots: {},
    validationWarning: {},
};
exports.addContactReducer = (0, toolkit_1.createReducer)(exports.initialAddContactState, (builder) => builder
    .addCase(addContactClearStore_1.addContactClearStore, () => exports.initialAddContactState)
    .addCase(addContactStep_1.addContactSetStep, (state, { payload }) => {
    return {
        ...state,
        step: payload,
    };
})
    .addCase(addContactLoadingSlot_1.addContactSetLoadingSlot, (state, { payload: { slot, loading } }) => {
    return {
        ...state,
        loadingSlots: {
            ...state.loadingSlots,
            [slot]: loading,
        },
    };
})
    .addCase(addContactWarning_1.addContactSetWarning, (state, { payload: { slot, isValid, message } }) => {
    return {
        ...state,
        validationWarning: {
            ...state.validationWarning,
            [slot]: {
                isValid,
                message,
            },
        },
    };
})
    .addCase(addContactWarning_1.addContactClearWarnings, (state) => {
    return {
        ...state,
        validationWarning: {},
    };
})
    // email
    .addCase(addContactEmailSendCodeSaga_1.addContactEmailSendCodeResponse, (state, { payload }) => {
    return {
        ...state,
        email: payload,
    };
})
    .addCase(addContactEmailResendCodeSaga_1.addContactEmailResendCodeResponse, (state) => {
    return state;
})
    .addCase(addContactEmailExchangeCodeSaga_1.addContactEmailExchangeCodeResponse, (state, { payload }) => {
    return {
        ...state,
        email: {
            ...state.email,
            ...payload,
        },
    };
})
    // phone
    .addCase(addContactPhoneSendCodeSaga_1.addContactPhoneSendCodeResponse, (state, { payload }) => {
    return {
        ...state,
        phone: payload,
    };
})
    .addCase(addContactPhoneResendCodeSaga_1.addContactPhoneResendCodeResponse, (state) => {
    return state;
})
    .addCase(addContactPhoneExchangeCodeSaga_1.addContactPhoneExchangeCodeResponse, (state, { payload }) => {
    return {
        ...state,
        phone: {
            ...state.phone,
            ...payload,
        },
    };
}));
const addContactStateSelector = (state) => state.addContact;
exports.addContactStateSelector = addContactStateSelector;
exports.addContactStepSelector = (0, toolkit_1.createSelector)(exports.addContactStateSelector, (_state) => _state.step);
exports.addContactLoadingSlotSelector = (0, toolkit_1.createSelector)([
    exports.addContactStateSelector,
    (_state, addContactLoadingSlot) => addContactLoadingSlot,
], (_state, addContactLoadingSlot) => !!_state.loadingSlots[addContactLoadingSlot]);
exports.addContactLoadingSlotsSelector = (0, toolkit_1.createSelector)([
    exports.addContactStateSelector,
    (_state, addContactLoadingSlots) => addContactLoadingSlots,
], (_state, addContactLoadingSlots) => addContactLoadingSlots.reduce((prev, current) => prev || !!_state.loadingSlots[current], false));
exports.addContactWarningSlotSelector = (0, toolkit_1.createSelector)([
    exports.addContactStateSelector,
    (_state, warningSlot) => warningSlot,
], (_state, warningSlot) => _state.validationWarning[warningSlot]);
exports.addContactEmailSelector = (0, toolkit_1.createSelector)(exports.addContactStateSelector, (_state) => _state.email);
exports.addContactPhoneSelector = (0, toolkit_1.createSelector)(exports.addContactStateSelector, (_state) => _state.phone);
